export default function StickyMobileCTA() {
  const go = (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/") {
      window.location.href = "/#contact";
    } else {
      document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 sm:hidden bg-white/95 backdrop-blur-md border-t border-slate-200 p-3" data-testid="sticky-mobile-cta">
      <a
        href="#contact"
        onClick={go}
        data-testid="sticky-mobile-cta-button"
        className="flex items-center justify-center w-full py-3.5 rounded-xl text-sm font-bold text-white bg-[#0f2b44] active:bg-[#1971c2] shadow-lg"
      >
        GET MY FREE WATER ANALYSIS
      </a>
    </div>
  );
}
